import { Component, ElementRef, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { xiloBtnStyle, xiloButtonSize, xiloTextTransform } from './button.model';

/**
* @description The button element is a directive of the xilo library
* @example <button xilo-button color="red">close</button>
* @param size changes the height of the button.
* @param textTransform defines the type of text to be displayed. Leverages the tailwind styles
* @param color defines the buttons style/theme
* @param disabled
*/
@Component({
  /*eslint-disable */
  selector: 'button[xilo-button], button[xiloButton]',
  host: {
    'class': 'xilo-lib-button',
    '[class.xilo-button--primary__transparent]': 'color === "primary-light"',
    '[class.xilo-button--red__transparent]': 'color === "red-light"',
    '[class.xilo-button--primary__border]': 'color === "primary-border"',
    '[class.xilo-button--red__solid]': 'color === "red"',
    '[class.xilo-button--primary__solid]': 'color === "primary"',
    '[class.xilo-button--primary__none]': 'color === "none"',
    '[class.uppercase]': 'textTransform === "uppercase"',
    '[class.normal-case]': 'textTransform === "titlecase"',
    '[class.lowercase]': 'textTransform === "lowercase"',
    '[class.xilo-button-small]': 'size === "small"',
    '[class.xilo-button-medium]': 'size === "medium"',
    '[class.xilo-button-large]': 'size === "large"',
    '[class.xilo-lib-button__disabled]': 'disabled',
    '[disabled]': 'disabled',
  },
  template:`<ng-content></ng-content>`,
  styleUrls: ['./button.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
  /*eslint-enable */
})

export class XiloButtonComponent {
  @Input() size: xiloButtonSize = 'medium';
  @Input() textTransform: xiloTextTransform = 'titlecase';
  @Input() color: xiloBtnStyle = 'primary-light';
  @Input() disabled: boolean;
}
